var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.423 9.744-.271-.144a.5.5 0 0 1-.267-.385l-.092-.782a.75.75 0 0 0-.482-.615l-1.203-.448a.5.5 0 0 1-.29-.285l-.53-1.354a.637.637 0 0 1 .5-.864l.928-.128a.755.755 0 0 0 .509-.308l.428-.6A5.72 5.72 0 0 0 8.188 1.69h-.092l.2 1.088a.5.5 0 0 1-.568.584.67.67 0 0 0-.76.408l-.256.711a.5.5 0 0 1-.613.31l-.464-.138a.537.537 0 0 0-.4.028.763.763 0 0 0-.318 1.082l.51.84c.137.223.38.36.642.36h.94c.078 0 .156.018.226.054l.953.483a.5.5 0 0 1 .27.383l.028.219a.69.69 0 0 0 .3.487l.534.357a.636.636 0 0 1 .104.972l-.765.79a.742.742 0 0 0-.185.327l-.567 2.1a5.728 5.728 0 0 0 5.516-3.391zm-7.876 2.839.062-.506a.958.958 0 0 0-.164-.661l-.932-1.342a.579.579 0 0 1 .069-.743.371.371 0 0 0-.078-.586L2.46 7.563a5.727 5.727 0 0 0 3.086 5.02zm2.64 1.917a7 7 0 1 1 0-14 7 7 0 0 1 0 14z",
    fill: "#BABFCB",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/region.84350b7d.svg";
export { ForwardRef as ReactComponent };